<template>
  <small v-if="text" class="text-typing">{{showText}}</small>

  <div v-else class="typing">
    <span></span>
    <span></span>
    <span></span>
  </div>
</template>

<script>
export default {
  props: {
    text: {
      type: String,
      default: '',
    },
  },

  data() {
    return {
      showText: '',
      isShowGroupAdd: true,
      isShowParticipantAdd: false,
    };
  },

  created() {
    if (this.text) {
      this.showText = this.text;
      let dots = 1;

      setInterval(() => {
        this.showText = `${this.text}${'.'.repeat(dots)}`
        dots = dots > 2 ? 1 : dots + 1;
      }, 350)
    }
  },

  methods: {
    showParticipantSection() {
      this.isShowGroupAdd = false;
      this.isShowParticipantAdd = true;
    },
    showGroupAddSection() {
      this.isShowGroupAdd = true;
      this.isShowParticipantAdd = false;
    },
  },
};
</script>

<style scoped>
.typing {
  position: relative;
  min-height: 8px;
}

.text-typing {
  color: #808080 !important;
  font-size: 12px;
  margin: 0;
  padding: 0;
}

span {
  content: '';
  animation: blink 1.5s infinite;
  animation-fill-mode: both;
  height: 6px;
  width: 6px;
  background: #424242;
  position: absolute;
  left: 0;
  top: 0;
  border-radius: 50%;
}

span:nth-child(2) {
  animation-delay: .2s;
  margin-left: 10px;
}

span:nth-child(3) {
  animation-delay: .4s;
  margin-left: 20px;
}


@keyframes blink {
  0% {
    opacity: .1;
  }
  20% {
    opacity: 1;
  }
  100% {
    opacity: .1;
  }
}

</style>
